$(document).ready(function () {
  $('.toggle-item .toggle-item--question').on('click', function () {
    $(this).toggleClass('active');
    $('+ .toggle-item--answer', this).toggleClass('active');
  });
  $(".toggle-item--question:first").addClass("active");
  $(".toggle-item--answer:first").addClass("active");
});